"use strict";
var publishBehavior_1 = require('../operators/publishBehavior');
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return publishBehavior_1.publishBehavior(value)(this);
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map


//////////////////
// WEBPACK FOOTER
// /builds/johannes-jonsson/consmin-app/~/rxjs/operator/publishBehavior.js
// module id = ../../../../rxjs/operator/publishBehavior.js
// module chunks = 3